import { render, staticRenderFns } from "./riesgosGenerales.vue?vue&type=template&id=764701d7&scoped=true&"
import script from "./riesgosGenerales.vue?vue&type=script&lang=js&"
export * from "./riesgosGenerales.vue?vue&type=script&lang=js&"
import style0 from "./riesgosGenerales.vue?vue&type=style&index=0&id=764701d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764701d7",
  null
  
)

export default component.exports